import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit, OnDestroy {
  private translate = inject(TranslateService);

  private readonly destroy = new Subject<void>();
  title = 'admin-dashboard';

  ngOnInit(): void {
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy))
      .subscribe((lang) => {
        document.querySelector('html')?.setAttribute('lang', lang.lang);
      });

    this.translate.addLangs(['hu']);
    this.translate.setDefaultLang('hu');
    this.translate.use('hu');
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
